module.exports = __webpack_public_path__ + "static/media/time.3f07b9a6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/time.svg
// module id = 1208
// module chunks = 0